<template>
	<div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
		<div>
			<div class="page_header">
				<span class="page_title"
					style="flex: 1;float:left">{{$t('violationManagement.violationmanagement')}}</span>

				<el-form :inline="true" class="demo-form-inline" size="small" style="float: right;">
					<el-form-item :label="$t('maintenancemanagement.carNo')">
						<el-input v-model="veCarNo" :placeholder="$t('maintenancemanagement.inputcarNo')"
							clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">{{$t("public.query")}}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" @click="newadd">{{$t("public.add")}}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button plain type="primary" @click="download">{{$t("public.export")}}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div style="background: #C5D0E2;height: 1px;margin:20px 0px"></div>
			<div style="display: flex;flex-direction: row;height: 100%;margin:20px 0px 20px 0px">
				<div style="display: flex;flex-direction: row;margin-right: 30px;position: relative;">
					<i style="vertical-align: -9%;margin-right: 10px;" class="iconfont icon-icon_tab_list"></i>
					<span
						style="font-size: 12px;font-weight: bold;display: contents;">{{$t('violationManagement.violationList')}}</span>

				</div>

				<!-- 	<div class="addbutton" @click="newadd">
					<el-link :underline="false" style="margin-right:20px"><i class="el-icon-plus"
							style="height: 16px;width:16px;font-weight:bold;"></i>
						{{$t("public.newbuilt")}}</el-link>
				</div> -->
			</div>
			<div style="margin: 20px 0px 0px 0px;">
				<el-table :data="tableData" border style="width:100%" :size="size" max-height="386" v-loading="loading">
					<el-table-column type="index" :label="$t('public.index')" align="center">
					</el-table-column>
					<el-table-column prop="CarNo" :label="$t('runState.carNo')" align="center">
					</el-table-column>
					<el-table-column prop="Driver" :label="$t('drivermanagement.driver')" align="center">
					</el-table-column>

					<el-table-column prop="FineAmount"
						:label="$t('violationManagement.penaltyamount')+$t('public.unit')" align="center">
					</el-table-column>
					<el-table-column prop="DeductionValue" :label="$t('violationManagement.deductionvalue')"
						align="center">
					</el-table-column>
					<el-table-column prop="ViolationTime" :label="$t('violationManagement.violationtime')"
						show-overflow-tooltip align="center">
					</el-table-column>
					<el-table-column prop="ViolationPlace" :label="$t('violationManagement.violationlocation')"
						show-overflow-tooltip align="center">
					</el-table-column>
					<el-table-column prop="TrafficOffence" :label="$t('violationManagement.violationbehavior')"
						show-overflow-tooltip align="center">
					</el-table-column>

					<el-table-column :label="$t('public.Operation')" align="center" width="180" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" type='success' @click="modify(scope.$index, scope.row)">{{ $t("public.edit")
				    }}</el-button>
							<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("public.del")
				    }}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-dialog class="addrepairlist" :title="violationtitle" :visible.sync="dialogFormVisible"
					:width="(LanguageId  == 1 ||LanguageId  == 2) ? '550px' : '700px'" :close-on-click-modal="false">
					<div style="background:#E8F0FF;height: 1px;"></div>
					<div class="registrationInfo">
						{{$t('violationManagement.violationinfo')}}
					</div>
					<el-row>
						<el-col :span="12">
							<div class="grid-content bg-purple">
								<el-form label-position="right" :model="violationInfo" size="mini"
									:label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '90px' : '175px'" :rules="rules"
									ref="violationInfo">
									<el-form-item :label="$t('maintenance.OPTName')+'：'" style="margin-top: 10px;">
										<el-input v-model="violationInfo.Entryclerk"
											:placeholder="$t('maintenancemanagement.inputperson')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('maintenancemanagement.carNo')" style="margin-top: 15px;"
										prop="VID">
										<el-select size="small" filterable v-model="violationInfo.VID"
											:placeholder="$t('public.select')">
											<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5"
												:key="item.nodeValue" :label="item.vehicleName" :value="item.nodeValue">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item :label="$t('violationManagement.penaltyamount')+'：'"
										style="margin-top: 15px;" prop="FineAmount">
										<el-input v-model="violationInfo.FineAmount"
							onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"	:placeholder="$t('violationManagement.inputpenaltyamount')"></el-input>
									</el-form-item>
									<el-form-item :label="$t('violationManagement.deductionvalue')+'：'"
										style="margin-top: 15px;" prop="DeductionValue">
										<el-input v-model.number="violationInfo.DeductionValue"
											:placeholder="$t('violationManagement.inputdeductionvalue')"></el-input>
									</el-form-item>
								</el-form>

							</div>
						</el-col>
						<el-col :span="12">
							<div class="grid-content bg-purple-light">
								<el-form label-position="right" :model="violationInfo" size="mini"
									:label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '90px' : '175px'">
									<el-form-item :label="$t('maintenance.entryTime')+'：'" style="margin-top: 10px;">
										<el-date-picker type="date" :placeholder="$t('accidentManagement.inputtime')"
											v-model="violationInfo.InputTime" :picker-options="pickerOptions"
											value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
									</el-form-item>
									<el-form-item :label="$t('drivermanagement.driver')+'：'" style="margin-top: 15px;">
										<el-input v-model="violationInfo.Driver"
											:placeholder="$t('drivermanagement.inputdriver')"></el-input>
									</el-form-item>

									<el-form-item :label="$t('violationManagement.violationtime')+'：'"
										style="margin-top: 15px;">
										<el-date-picker type="date"
											:placeholder="$t('violationManagement.inputviolationtime')"
											v-model="violationInfo.ViolationTime" style="width: 100%;"
											value-format="yyyy-MM-dd" :picker-options="pickerOptions"></el-date-picker>

									</el-form-item>
								</el-form>
							</div>
						</el-col>

					</el-row>
					<el-form :inline="true" :model="violationInfo" class="demo-form-inline" label-position="right"
						:label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '90px' : '175px'" style="margin-top: 10px;">
						<el-form-item :label="$t('violationManagement.violationlocation')+'：'">
							<el-input type="textarea" v-model="violationInfo.ViolationPlace"
								:placeholder="$t('violationManagement.inputviolationlocation')"></el-input>
						</el-form-item>

						<el-form-item :label="$t('violationManagement.violationdescription')+'：'">
							<el-input type="textarea" v-model="violationInfo.TrafficOffence"
								:placeholder="$t('violationManagement.inputviolationdescription')" maxlength="100"
								show-word-limit></el-input>
						</el-form-item>
					</el-form>

					<div slot="footer" class="dialog-footer" style="text-align: right;margin:10px 0px 20px 10px">
						<el-button size="small" @click="dialogFormVisible = false">{{$t('public.cancel')}}</el-button>
						<el-button size="small" type="primary"
							@click="determine('violationInfo')">{{$t('public.confirm')}}</el-button>
					</div>

				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import language from '@/utils/getLanguageId';
	import {
		mapState
	} from 'vuex'
	export default {
		name:"violationManagement",
		data() {
			return {
				LanguageId: 1,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				loading: true,
				veCarNo: "",
				form: {},
				dialogFormVisible: false,
				tableData: [],
				violationInfo: {},
				violationtitle: "",
				violationNo: "",
				rules: {
					VID: [{
						required: true,
						message: this.$t('maintenancemanagement.selectvehicle'),
						trigger: 'change'
					}],
					FineAmount: [{
							required: true,
							message: this.$t('violationManagement.inputpenaltyamount'),
							trigger: 'blur'
						},
						{
							pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
							message: this.$t('maintenancemanagement.validamount'),
							trigger: "blur"
						}
					],
					// VID: [{
					// 	required: true,
					// 	message: '请选择车辆',
					// 	trigger: 'change'
					// }],
					DeductionValue: [{
						pattern: /^(0|[1-9][0-9]*)$/g,
						message: this.$t('maintenancemanagement.validnumber'),
						trigger: "blur"

					}]
				}

			}
		},
		mounted() {
			this.queryPeccancyInfo(0);
			this.LanguageId = language(this.$store.getters.locale);
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				vehicles: state => state.app.vehicles,
			})
		},

		methods: {
			queryPeccancyInfo(type) {
				var that = this;
				this.$api.queryPeccancyInfo({
					CarNo: this.veCarNo,
					IsExport: type,
					OperatorID: this.operator.OperatorId,
				}).then((res) => {
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.tableData = parseObj.data;
									that.loading = false;
								} else {
									that.loading = false;
									that.tableData = [];
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download", that.$t('violationManagement.violationstatistics') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}

				})
			},

			newadd() {
				this.dialogFormVisible = true;
				this.violationtitle = this.$t('violationManagement.violationregistration');
				this.violationInfo = {};
				this.$nextTick(() => {
					this.$refs["violationInfo"].clearValidate()
				})
				this.violationInfo.Entryclerk = this.operator.OpeName;
				this.$set(this.violationInfo, "ViolationTime", new Date());
				this.$set(this.violationInfo, "InputTime", new Date());

			},
			determine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.violationtitle == this.$t('violationManagement.violationregistration')) {
							this.savePeccancyInfo(0, 1, this.$t('public.add_success'));
						} else if (this.violationtitle == this.$t('violationManagement.modifyviolationrecords')) {
							this.savePeccancyInfo(this.violationNo, 2, this.$t('public.edit_success'));
						}
					} else {
						// console.log('error submit!!');
						return false;
					}
				});


			},
			savePeccancyInfo(violationNo, type, message) {
				this.$api.savePeccancyInfo({
					PeccancyID: violationNo,
					Entryclerk: this.violationInfo.Entryclerk,
					InputTime: this.violationInfo.InputTime,
					V_ID: this.violationInfo.VID,
					Driver: this.violationInfo.Driver,
					ViolationTime: this.violationInfo.ViolationTime,
					FineAmount: parseInt(this.violationInfo.FineAmount) * 100,
					DeductionValue: this.violationInfo.DeductionValue,
					ViolationPlace: this.violationInfo.ViolationPlace,
					TrafficOffence: this.violationInfo.TrafficOffence,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						this.dialogFormVisible = false;
						this.violationInfo = {};
						this.$message({
							type: 'success',
							message: message,
						});
						this.queryPeccancyInfo(0);
					} else {
						this.$message({
							type: 'info',
							message: res.message,
						});
					}
				})

			},
			download() {
				this.queryPeccancyInfo(1);
			},
			modify(index, row) {
				console.log(index)
				console.log(row)
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs["violationInfo"].clearValidate()
				})
				this.violationtitle = this.$t('violationManagement.modifyviolationrecords');
				const {
					Entryclerk,
					VID,
					ViolationTime,
					DeductionValue,
					InputTime,
					Driver,
					FineAmount,
					ViolationPlace,
					TrafficOffence,
				} = row;
				let newvehicle = this.vehicles.data.filter((item, index) => {
					return item.treeLevel == 5
				})
				newvehicle.forEach(function(item, index) {
					if (item.vehicleName == row.CarNo) {
						row.VID = item.nodeValue;
					}
				});
				this.violationInfo = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝
				this.violationNo = this.violationInfo.PeccancyID;

			},
			handleDelete(index, row) {
				this.$confirm(this.$t('maintenance.confirmDelete') + '?', this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText: this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					const {
						CarNo,
						DeductionValue,
						Driver,
						Entryclerk,
						FineAmount,
						InputTime,
						PeccancyID,
						TrafficOffence,
						ViolationPlace,
						ViolationTime,
					} = row;
					this.violationInfo = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝
					this.savePeccancyInfo(this.violationInfo.PeccancyID, 3, this.$t('public.hasDeleted'));
					// row.splice(index, 1);
				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},
			onSubmit() {
				this.queryPeccancyInfo(0);

			},
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.addrepairlist   {
		::v-deep	.el-dialog {
			height: 500px;
		}
	}

	.addbutton {
		text-align: right;
		right: 0;
		position: absolute;
		margin-right: 40px;
	}

	.registrationInfo {
		margin-top: 20px;
		font-size: 12px;
		text-align: left;
		font-weight: bold !important;
		margin-left: 20px;
		color: black;
	}

	.addrepairlist  {
		::v-deep	.el-form-item__label {
			font-size: 12px;
		}
	}

	.addrepairlist   {
		::v-deep	.el-textarea__inner {
			width: 400px;
			font-size: 12px;
		}
	}

	.demo-form-inline   {
		::v-deep	.el-form-item__label {
			font-size: 12px;
		}
	}
</style>